/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeletePayoutTableResponse
 */
export interface DeletePayoutTableResponse {
    /**
     * 
     * @type {boolean}
     * @memberof DeletePayoutTableResponse
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DeletePayoutTableResponse
     */
    message?: string;
}

/**
 * Check if a given object implements the DeletePayoutTableResponse interface.
 */
export function instanceOfDeletePayoutTableResponse(value: object): value is DeletePayoutTableResponse {
    return true;
}

export function DeletePayoutTableResponseFromJSON(json: any): DeletePayoutTableResponse {
    return DeletePayoutTableResponseFromJSONTyped(json, false);
}

export function DeletePayoutTableResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeletePayoutTableResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function DeletePayoutTableResponseToJSON(json: any): DeletePayoutTableResponse {
    return DeletePayoutTableResponseToJSONTyped(json, false);
}

export function DeletePayoutTableResponseToJSONTyped(value?: DeletePayoutTableResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
    };
}

